import { Outlet, useParams } from 'react-router'
import RouteTabs from '@/components/common/RouteTabs'
import type { RouteTabItem } from '@/components/common/RouteTabs'

export default function ProvidersLayout() {
  const { clientId } = useParams<{ clientId: string }>()
  if (!clientId) return null

  const base = `/workspace/clients/${clientId}`
  const tabs: RouteTabItem[] = [
    { label: 'Directory', href: `${base}/directory` },
    { label: 'Campaigns', href: `${base}/outreach-campaigns` },
    // { label: 'Activity', href: `${base}/outreach` },
  ]

  return (
    <RouteTabs tabs={tabs}>
      <Outlet />
    </RouteTabs>
  )
}
